/** Live vault on axiome-1 (code 252 / 0.1.6). */

export const DEFAULT_VAULT_ADDRESS =
  "axm19yc7r0ckx7sgky9t8ylj8p6sxwlj46qck0t84hrm22lqtvx586ss7jyda6";

export const DEFAULT_ADMIN_ADDRESS =
  "axm1l7jqljrjgxshdyr7lw0eyqjq3wjvydgfcd7x5w";

const envVault = (import.meta.env.VITE_VAULT_ADDRESS as string | undefined)?.trim() ?? "";

export const VAULT_ADDRESS =
  envVault && !/placeholder/i.test(envVault) ? envVault : DEFAULT_VAULT_ADDRESS;

export const HAS_LIVE_VAULT = VAULT_ADDRESS.startsWith("axm1") && VAULT_ADDRESS.length >= 40;

export const ADMIN_ADDRESS =
  (import.meta.env.VITE_ADMIN_ADDRESS as string | undefined)?.trim() ||
  DEFAULT_ADMIN_ADDRESS;

/**
 * REST must be same-origin on HTTPS (Cloudflare / TMA) to avoid mixed-content.
 * Vite proxies /axiome-rest → Axiome LCD.
 */
function pickApiUrl(envKey: "VITE_AXIOME_REST" | "VITE_INDEXER_URL", proxyPath: string, fallback: string): string {
  const raw = (import.meta.env[envKey] as string | undefined)?.trim();
  if (typeof window !== "undefined" && window.location.protocol === "https:") {
    // Prefer explicit relative proxy, or force proxy if env is http://
    if (raw?.startsWith("/")) return raw.replace(/\/$/, "");
    if (!raw || raw.startsWith("http://")) return proxyPath;
    return raw.replace(/\/$/, "");
  }
  if (raw) return raw.replace(/\/$/, "");
  // Local http://localhost — also use proxy for consistency
  if (typeof window !== "undefined" && window.location.hostname === "localhost") {
    return proxyPath;
  }
  return fallback;
}

export const REST_URL = pickApiUrl(
  "VITE_AXIOME_REST",
  "/axiome-rest",
  "https://api-chain.axiomechain.org",
);

export const INDEXER_URL = pickApiUrl(
  "VITE_INDEXER_URL",
  "/axiome-indexer",
  "https://api-idx.axiomechain.pro",
);

export const CONNECT_API =
  (import.meta.env.VITE_CONNECT_API as string | undefined)?.trim() || "https://aback-d.ru";
